export class GlobalConstants {
  public static language: string = "";
  public static calculatorFocus: boolean = false;
  public static languageChangeFunctionCallInHeader: boolean = false;
}